"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var GoogleMap_1 = __importDefault(require("~/components/maps/locations/GoogleMap"));
var GoogleMapStore_1 = __importDefault(require("~/stores/maps/locations/GoogleMapStore"));
var IndexContainer = function (props) {
    return (react_1.default.createElement(mobx_react_1.Provider, { googleMapStore: new GoogleMapStore_1.default() },
        react_1.default.createElement(GoogleMap_1.default, __assign({}, props))));
};
exports.default = IndexContainer;
